import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";

export const Section09 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        // console.log(currentFrame)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    return (
        <animated.div className={`${styles['animation-container']} ${styles['z-index-10']} ${styles['white-like-background']}`} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <div className={`${styles.sec} ${styles.sec09} ${styles['z-index-10']}`}>
                <animated.p className={`${styles.sec09__font01} ${styles.marginDel}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.1, 0.3, 2.5, 2.6],
                        output: [0, 0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.1, 0.3, 1, 2.4, 2.6],
                        output: [10, 10, 0, 0, 0, -10]
                    }).to(x => `${x}vh`)
                }}>참여할 때마다</animated.p>
                <animated.p className={`${styles.sec09__font02} ${styles.notoBold} ${styles.marginDel}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.1, 0.3, 2.5, 2.6],
                        output: [0, 0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.1, 0.3, 1, 2.4, 2.6],
                        output: [10, 10, 0, 0, 0, -10]
                    }).to(x => `${x}vh`),
                    WebkitTextFillColor: spring.x.to({
                        range: [0.8, 1.5, 2],
                        output: [0, 1, 1]
                    }).to(x => `rgba(0, 0, 0, ${x})`)
                }}>자산이 쌓이는</animated.p>
            </div>
            <animated.svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve"
                          className={styles['section-default']}>
                <animated.rect className={styles['section09-transition__background']}
                               style={{
                                   fillOpacity: spring.x.to({
                                       range: [2, 2.5, 3],
                                       output: [0, 0, 1]
                                   }).to(x => x),
                               }}/>
                <animated.rect className={styles['section09-transition__drop-box']} height="100vh"
                               style={{
                                   height: spring.x.to({
                                       range: [2, 2.5, 3],
                                       output: [0, 100, 100]
                                   }).to(x => `${x}vh`),
                                   opacity: spring.x.to({
                                       range: [2, 2.1, 2.5, 2.501, 3],
                                       output: [0, 1, 1, 0, 0]
                                   }).to(x => x)
                               }}/>
                <animated.rect className={styles['section09-transition__leftside-box']}
                               style={{
                                   opacity: spring.x.to({
                                       range: [2, 2.5, 2.501, 3],
                                       output: [0, 0, 1, 1]
                                   }).to(x => x),
                                   translateX: spring.x.to({
                                       range: [2, 2.501, 3],
                                       output: [0, 0, -50]
                                   }).to(x => `${x}vw`),
                               }}/>
                <animated.rect className={styles['section09-transition__rightside-box']}
                               style={{
                                   opacity: spring.x.to({
                                       range: [2, 2.5, 2.501, 3],
                                       output: [0, 0, 1, 1]
                                   }).to(x => x),
                                   translateX: spring.x.to({
                                       range: [2, 2.501, 3],
                                       output: [0, 0, 50]
                                   }).to(x => x === 0 ? '' : `${x}vw`),
                               }}/>
            </animated.svg>
        </animated.div>
    )
}